import React from 'react'
import { Drawer } from '@mui/material'
import { makeStyles } from '@mui/styles'
import PowerCurveForm from '../components/forms/PowerCurveForm'

const sitesListWidth = 350

const useStyles = makeStyles(theme => ({
  childrenContainer: {
    marginLeft: sitesListWidth,
    width: `calc(100% - ${sitesListWidth}px)`,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 20px',
    borderLeft: `${theme.palette.menu.border} 1px solid`,
    overflowY: 'auto',
    overflowX: 'auto',
  },
  drawer: {
    borderRight: `${theme.palette.menu.border} 1px solid`,
    width: sitesListWidth,
  },
}))

const PowerCurvePanel = props => {
  const classes = useStyles(props)
  const { container, onRun, disableButton, trackDisableStatus } = props

  return (
    <>
      <Drawer
        open={true}
        variant="persistent"
        anchor="left"
        ModalProps={{
          keepMounted: true,
          container: container.current,
          style: { position: 'absolute' },
        }}
        PaperProps={{
          style: { position: 'absolute' },
        }}
        classes={{ paper: classes.drawer }}
      >
        <PowerCurveForm
          onRun={onRun}
          disableButton={disableButton}
          trackDisableStatus={trackDisableStatus}
        />
      </Drawer>
      <div className={classes.childrenContainer}>{props.children}</div>
    </>
  )
}

export default PowerCurvePanel
